import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { Anchor, ContentLiner, Flex } from '@fttb/common/components';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { withAnalyticsOnBlockView } from "../hoc/withAnalyticsOnView";
import { getAnalyticEventType } from "../../store/blocks/selectors";
import { getTariffTabsList, getTariffsTitle } from "../../store/blocks/tariffs/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
import { AddressNotification, TariffBenefitsGrid, TariffBenefitsItem, TariffBg, TariffButton, TariffCard, TariffDescription, TariffGift, TariffImage, TariffName, TariffParameters, TariffPrice, TariffTags, TariffValue, TariffValueGroupHeading, TariffValueGroups, TariffValues, TariffsBlockHeading, TariffsBlockTabs, TariffsGrid } from "./components";
var _TariffsBlock = function _TariffsBlock(_ref) {
  var className = _ref.className,
    containerRef = _ref.containerRef;
  return /*#__PURE__*/React.createElement(ContentLiner, {
    className: className,
    "data-t-id": "blocks-TariffsBlock"
  }, /*#__PURE__*/React.createElement(Anchor, {
    anchorId: FttbBlocks.TARIFFS,
    "data-t-id": "blocks-TariffsBlock"
  }), /*#__PURE__*/React.createElement(TariffsBlockHeading, {
    className: "mar-b-m"
  }), /*#__PURE__*/React.createElement(TariffsBlockTabs, {
    className: "mar-b-m"
  }), /*#__PURE__*/React.createElement(AddressNotification, {
    className: "mar-b-m"
  }), /*#__PURE__*/React.createElement(TariffsGrid, {
    className: "pad-b-l"
  }, /*#__PURE__*/React.createElement(TariffsGrid.Item, null, /*#__PURE__*/React.createElement(TariffCard.Link, null, /*#__PURE__*/React.createElement(TariffCard.Section, {
    overlay: /*#__PURE__*/React.createElement(TariffBg, null, /*#__PURE__*/React.createElement(TariffImage, {
      "data-t-id": "blocks-TariffsBlock"
    })),
    side: "top"
  }, /*#__PURE__*/React.createElement(Flex, {
    className: "mar-b-2xl",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(TariffName, {
    "data-t-id": "blocks-TariffsBlock"
  }), /*#__PURE__*/React.createElement(TariffTags, {
    className: "mar-l-xs",
    containerRef: containerRef
  })), /*#__PURE__*/React.createElement(TariffValueGroups, null, /*#__PURE__*/React.createElement(TariffValueGroupHeading, {
    className: "mar-b-2xs",
    "data-t-id": "blocks-TariffsBlock"
  }), /*#__PURE__*/React.createElement(TariffValues, {
    className: "mar-b-s"
  }, /*#__PURE__*/React.createElement(TariffValue, {
    className: "mar-b-2xs",
    "data-t-id": "blocks-TariffsBlock"
  })))), /*#__PURE__*/React.createElement(TariffCard.Section, {
    side: "bottom"
  }, /*#__PURE__*/React.createElement(TariffBenefitsGrid, {
    className: "mar-b-m mar-t-2xs",
    wrap: "wrap"
  }, /*#__PURE__*/React.createElement(TariffBenefitsItem, {
    containerRef: containerRef,
    "data-t-id": "blocks-TariffsBlock"
  })), /*#__PURE__*/React.createElement(TariffParameters, {
    className: "mar-b-s"
  }), /*#__PURE__*/React.createElement(TariffDescription, {
    className: "mar-b-s"
  }), /*#__PURE__*/React.createElement(TariffCard.Spacer, null), /*#__PURE__*/React.createElement(TariffGift, {
    className: "mar-t-s"
  }), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    className: "mar-t-s",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(TariffPrice, {
    "data-t-id": "blocks-TariffsBlock"
  }), /*#__PURE__*/React.createElement(TariffButton, {
    isPopular: false
  })))))));
};
_TariffsBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    analyticBlockTitle: getTariffsTitle(state),
    pageType: getAnalyticEventType(state),
    shouldRender: !isEmpty(getTariffTabsList(state))
  };
};
var _TariffsBlockHOC = withAnalyticsOnBlockView(_TariffsBlock);
export var TariffsBlock = compose(connect(mapStateToProps), defineBlock(FttbBlocks.TARIFFS), withRenderFlag)(_TariffsBlockHOC);